<template>
  <daiban-tool :flow="flow"> </daiban-tool>
</template>
<script>
import daibanTool from "./daibanTool.vue";
export default {
  components: { daibanTool },
  data() {
    return {
      flow: {
          id: "1620714615765766145",
          name: "高危作业",
          name1: "高危待办处理",
        },
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/yhgl/daibanchuligaowei.vue